export default "__VITE_ASSET__Dc0A90GS__"